import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import BadgeDescription from './BadgeDescription';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as animationHelper from "../../../helpers/animationHelper";

class BadgeOverview extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            status: objectConstants.STATUS_NOT_STARTED,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            bite_id: this.props.callbacks.getBiteId(),
            badgeUserData: this.props.badgeUserData,
            locale: appHelper.getLocalData(this.props.screenObject),
            badges: this.props.badges,
            showAchieved: false,
            screenStatus: "",
            checkComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            continue_label: appHelper.getLocaleString("continue_label")
        };

        this.show = this.show.bind(this);
        this.getUserBadge = this.getUserBadge.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);

        this.badgeRef = React.createRef();
    }

    componentDidMount() {
        this.show();
        this.getScreenStatus();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkComplete) {
            this.onComplete();
        }
    }

    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let object = this.refs[`badge_overview`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(object.offsetTop, true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    getUserBadge(badge) {
        return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.onComplete();
        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            } else {
                this.setState({checkComplete: true});
            }

        }

    }


    onObjectComplete(kpi) {
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "kpi_id", kpi.kpi_id);
        if (index === -1) {
            this.setState(
                {
                    completeObjects: dataHelper.immutablePush(this.state.completeObjects, kpi),
                    status: objectConstants.STATUS_IN_PROGRESS
                }
            );
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
            if (!hasNextObject) {
                this.handleProgression();
                this.enableProgression();
            } else {
                this.enableProgression();
            }

        } else {
            this.handleProgression();
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);

    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index)) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    show() {
        let badgeRef = this.badgeRef.current;
        if(appHelper.isObjectEleDefined(badgeRef)) {
            let params = {
                ele: badgeRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.getObjectStatus
            };
            animationHelper.showHeight(params);
        }
    }

    render() {

        return (
            <div className="a-c" ref={this.badgeRef}>
                <div className={`object-container`}>
                    {
                        this.state.screenObject.show_title && this.state.locale.label !== null && appHelper.isDefined(this.state.locale.label)
                            ?
                            <h4 className={objectConstants.DEFAULT_HEADING_CLASS}
                                dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                            :
                            null
                    }
                    {
                        appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                            ?
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            :
                            null
                    }
                    {(this.state.screenObject.show_title && this.state.locale.label !== null && appHelper.isDefined(this.state.locale.label)) || appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                        ?
                        <br/>
                        :
                        null
                    }

                    <div className="kpi-overview-panel">
                        {this.state.badges.map(badge =>
                            <BadgeDescription key={badge.badge_id} badge={badge} userBadge={this.getUserBadge(badge)}
                                              showAchieved={this.state.showAchieved} bite_id={this.state.bite_id}/>
                        )}
                    </div>
                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>

        );
    }
}

BadgeOverview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    badges: PropTypes.array.isRequired,
    badgeUserData: PropTypes.array.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    trackingData: PropTypes.object
};

BadgeOverview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let biteBadges = appHelper.getArrayObjectByKey(localStorage.bites, "bite_id", ownProps.callbacks.getBiteId()).badges;

    let badges = ownProps.screenObject.display_method === objectConstants.DISPLAY_ALL_BADGES ? state.contentData.experience.badges : biteBadges;
    let badgeUserData = ownProps.screenObject.display_method === objectConstants.DISPLAY_ALL_BADGES ? state.userData.badges : userDataHelper.getUsersDataBadges(state.contentData.experience.badges, biteBadges);
    let lang = state.userData.lang;
    return {
        lang: lang,
        userData: state.userData,
        trackingData: state.trackingData,
        badges: badges,
        badgeUserData: badgeUserData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BadgeOverview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/BadgeOverview.js
 **/